/*
 * actionOnExpandedSelection(editor, callback_function) is a reusable Plugin.
 * It takes two params. One is an instance of `editor` and other is a callback function.
 * It first selects the entire word in which the cursor is placed and then the callback fuction is called.
 */
import isInbetween from './isInbetween';
import selectFromStartToCursor from './selectFromStartToCursor';
import selectFromCursorToEnd from './selectFromCursorToEnd';

const actionOnExpandedSelection = (editor, func) => {
  const { selection: initialSelection } = editor.value;
  if (initialSelection.isExpanded) {
    func();
    return;
  }
  if (isInbetween(editor)) {
    selectFromStartToCursor(editor);
    selectFromCursorToEnd(editor);
    func();
    editor.select(initialSelection);
  } else {
    func();
  }
};
export default actionOnExpandedSelection;
